import { useEffect } from 'react';
import { applySeo } from '../../lib/seo';

/**
 * Declarative SEO for a route. Renders nothing; writes to <head> on mount/update.
 * Props mirror applySeo(). JSON-LD may be an object or an array of objects.
 */
export const Seo = (props) => {
  const serialized = JSON.stringify(props);
  useEffect(() => {
    applySeo(props);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [serialized]);
  return null;
};
